import { type FunctionComponent } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'applinks.heading',
    defaultMessage: 'Welcome to {customer}',
    description:
      'Heading for applinks, welcoming the user to the customer app (Jira or Confluence)',
  },
});

const Header: FunctionComponent<{ appName: string }> = ({ appName }) => {
  return (
    <FormattedMessage
      {...messages.title}
      values={{ customer: appName }}
      tagName="h1"
    />
  );
};

export default Header;
